module.exports = __webpack_public_path__ + "static/media/ke.812cbb83.png";